


















import {Component, Vue, Prop} from 'vue-property-decorator'
import SurveyModel from '@/classes/SurveyModel'
import {Task} from '@/store/types'

@Component({})
export default class TaskStatus extends Vue {
  @Prop(Object) public task!: Task

  public SurveyModel = SurveyModel

}

